export default {
  value: {
    type: [String, Array],
    default: "",
  },

  onSuccess: { // 上传成功回调
    type: Function,
    default: () => {
    },
  },

  onRemove: { // 删除回调
    type: Function,
    default: () => {
    },
  },

  // 手动处理上传结果 布尔类型
  manual: {
    type: Boolean,
    default: false,
  },

  downloadUrl: { // 回显拼接域名
    type: String,
    default: ""
  },

  width: { // 宽度
    type: String,
    default: "148px"
  },
  height: { // 高度
    type: String,
    default: "148px"
  },
  showFileList: { // 是否使用el-upload 显示文件列表
    type: Boolean,
    default: false,
  },
  listType: { // 显示文件类型，默认 picture-card 若是使用其他类型 showFileList 必须为true
    type: String,
    default: "picture-card",
  },

  disabled: {
    type: Boolean,
    default: false,
  }
}
